import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { Box, Card, CardHeader, Button, Typography } from '@mui/material';
import {
  Sync as SyncIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useJobs } from '@/hooks/useSync';

const SettingsPage: React.FC = () => {
  const { t } = useTranslation('pages');
  const navigate = useNavigate();
  // Newest scraper job of any type — what ran, when, and how it ended.
  const { data: jobs = [] } = useJobs(undefined, 1);
  const lastJob = jobs[0] ?? null;

  // Naive server-local ISO string — parsed as-is, never forced to UTC.
  const lastJobAt = lastJob?.started_at ?? lastJob?.created_at ?? null;
  const lastJobSummary = lastJob
    ? [
        t(`sync.jobTypes.${lastJob.job_type}`, { defaultValue: lastJob.job_type }),
        lastJobAt ? formatDistanceToNow(new Date(lastJobAt), { addSuffix: true }) : '—',
        t(`sync.status.${lastJob.display_status}`),
      ].join(' · ')
    : null;

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        {t('settings.title')}
      </Typography>

      {/* Sync card */}
      <Card sx={{ mt: 3 }}>
        <CardHeader
          avatar={<SyncIcon sx={{ fontSize: 32 }} color="primary" />}
          title={t('sync.title')}
          subheader={
            lastJobSummary
              ? `${t('sync.lastRun')}: ${lastJobSummary}`
              : t('sync.intro')
          }
          action={
            <Button
              variant="outlined"
              size="small"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate('/sync')}
            >
              {t('sync.open')}
            </Button>
          }
        />
      </Card>
    </Box>
  );
};

export default SettingsPage;
